import { InvoiceSettings } from './client-directory';
import { User } from './user';
import { Order } from './order';
import { Organization, PaymentDetails } from './organization';
import { OrganizationContact } from './contact';

export type TotalAmount = {
    totalPrice: number;
    vatAmount?: number;
    currency?: string;
    averagePrice?: number;
    totalIncVat?: number;
};

// Backed values
export enum InvoicingType {
    SINGLE = 'SINGLE',
    COLLECTIVE = 'COLLECTIVE',
    COLLECTIVE_DENTIST = 'COLLECTIVE_DENTIST',
}

// Backend values
export enum InvoiceDelivery {
    SCHEDULED_ELECTRONIC = 'SCHEDULED_ELECTRONIC',
    ELECTRONIC_BILLING = 'ELECTRONIC_BILLING',
    PRINT = 'PRINT',
    EMAIL = 'EMAIL',
    EXTERNAL_INVOICE_SYSTEM = 'EXTERNAL_INVOICE_SYSTEM',
}

export enum InvoicePeriod {
    MONTHLY = 'MONTHLY',
    SEMI_WEEKLY = 'SEMI_WEEKLY',
    WEEKLY = 'WEEKLY',
}

export enum OrderOnDate {
    NO_DATE_FILTER = 'NO_DATE_FILTER',
    ORDER_DELIVERED = 'ORDER_DELIVERED',
    ORDER_CREATED = 'ORDER_CREATED',
}

export type MonetaryTotal = {
    currency: string;
    total: number;
    vat: number;
    totalIncVat: number;
};

export type InvoiceLineItem = {
    order?: Order | string;
    currency?: string;
    note?: InvoiceNote | string;
    description: string;
    articleNo: string;
    quantity: number;
    itemPrice: number;
    itemVat: number;
    itemVatPercentage: number;
    totalIncVat: number;
    isManual?: boolean;
    isIdentifyingRow?: boolean;
    totalExclVat?: number;
    id?: number;
};

export enum Type {
    DEBIT = 'DEBIT',
    CREDIT = 'CREDIT',
}

export type Invoice = {
    _id: string;
    mainClinic: Organization;
    dentist?: User;
    invoiceNumber: string;
    currency: string;
    invoiceText?: string;
    supplier: InvoiceParty;
    customer: InvoiceParty;
    deliveryAddress: InvoiceParty;
    pdfUrl: string;
    deliveryNotesPdfUrl: string;
    invoiceSpecificationPdfUrl: string;
    invoiceType: string;
    createdDate: Date;
    invoiceDate: Date;
    dueDate: Date;
    sentDate: Date;
    paidOn?: Date;
    paymentStatus?: InvoicePaymentStatus;
    status: string;
    processingErrorMessage?: string;
    gln?: string;
    vatNumber?: string;
    ocrNumber?: string;
    costCenter?: string;
    deliveryMethod: string;
    total: MonetaryTotal;
    lineItems: InvoiceLineItem[];
    paymentTerm: number;
    invoiceSettings?: InvoiceSettings;
    description: string;
    orderNumber: string;
    paymentDetails: PaymentDetails;
    lineItemWithOrderCount?: number;
    certifiedOrderCount?: number;
    type: Type;
    debitInvoice?: Invoice;
    creditInvoices?: Invoice[];
    isCredited?: boolean;
    orders: string[];
    order: string | Order;
    ourReference?: string;
};

export type InvoiceParty = {
    name: string;
    number: string;
    reference: string;
    contact: OrganizationContact;
    countryCode: string;
};

export enum InvoicePaymentStatus {
    ALL = 'ALL',
    PAID = 'PAID',
    UNPAID = 'UNPAID',
}

export type InvoiceNote = {
    _id?: string;
    type: Type;
    currency?: string;
    lab?: string;
    clinic: Organization;
    dentist?: User | undefined;
    invoice?: Invoice;
    description: string;
    quantity: number;
    itemPrice: number;
    itemVatPercentage: number;
    itemVat: number;
    totalExclVat: number;
    totalIncVat: number;
};
